/* eslint-disable max-len */
<template>
  <div class="bottomDock">
    <ul
      class="list-group d-inline-flex flex-row justify-content-center m-3 bottomDock__list"
    >
      <li class="dock-icons">
        <SpeechRecognition />
      </li>
      <QuestBottomControls />
      <li class="dock-icons">
        <a
          @click="saveToThoughtMap()"
          class="position-relative bottom-dock-btn"
        >
          <i class="bottom-dock-btn__icon bx bx-save" title="Save Current Thought to Quest"></i>
        </a>
      </li>
      <li class="dock-icons">
        <ShareCollaborate />
      </li>
      <ModifyLayout />
      <li class="dock-icons" title="Add new Panel">
        <div class="bottom-dock-btn">
          <i
            class="d-flex bottom-dock-btn__icon bx bx-window-alt"
            @click="addPanel"
            title="Add new Panel"
          ></i>
        </div>
      </li>
      <li class="dock-icons">
        <a @click="toggleCamera()" class="bottom-dock-btn">
          <i
            name="camera"
            :class="`bottom-dock-btn__icon bx bx-camera ${iconClass}`"
            title="Toggle Camera"
          ></i>
        </a>
      </li>
      <ScreenRecorder v-if="abilities.can('note', 'ScreenRecording')" />
    </ul>
  </div>
</template>

<script>
import ModifyLayout from '@/components/ModifyLayout.vue';
import SpeechRecognition from '@/components/SpeechRecognition.vue';
import ShareCollaborate from '@/components/ShareCollaborate.vue';
import ScreenRecorder from '@/components/ScreenRecorder.vue';
import AbilityMixin from '@/mixins/AbilityMixin';
import QuestBottomControls from './QuestBottomControls.vue';

export default {
  name: 'BottomDock',
  components: {
    SpeechRecognition,
    ShareCollaborate,
    ModifyLayout,
    ScreenRecorder,
    QuestBottomControls,
  },
  mixins: [AbilityMixin],

  computed: {
    iconClass() {
      console.log(this.$store.state.cameraStatus);
      return this.$store.state.cameraStatus ? 'icon-active' : 'icon-inactive';
    },

  },

  mounted() {
    this.$root.$on('savethoughtmap', this.saveToThoughtMap);
    this.$root.$on('openCamera', this.toggleCamera);
    this.$root.$on('addNewPanel', this.addPanel);
  },
  beforeDestroy() {
    this.$root.$off('savethoughtmap');
    this.$root.$off('openCamera');
    this.$root.$off('addNewPanel');
  },
  methods: {
    saveToSnapshot() {
      this.$store.dispatch('saveStateToSnaphot');
    },

    saveToThoughtMap() {
      this.$store.dispatch('sendUpdateToThoughtMap');
    },

    toggleCamera() {
      this.$store.dispatch('toggleCameraStatus');
    },

    addPanel() {
      this.$root.$emit('addPanel', this.$route.name);
    },
  },
};
</script>

<style lang="scss" scoped>
.bottomDock {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
}

// .dock-icons {
//   padding: 0.5rem 0.4rem;
//   position: relative;
//   display: block;
//   padding: 0.5rem 1rem;
//   color: #212529;
//   text-decoration: none;
//   background-color: #fff;
// }

.bottomDock__list {
  // box-shadow: 0em 0.125em 0.3125em rgba(0, 0, 0, 0.1);
  max-width: 80vmin;
  // flex-wrap: wrap;
}

.list-group-item {
  border: none;
}

// .list-group-item + .list-group-item {
//   border-left: 0.03125em solid rgba(0, 0, 0, 0.2);
// }

@media screen and (max-width: 768px) {
  .bottomDock {
    display: none
  }
}
</style>
